import { Navigation } from "components/Navigation";
import { AdvHeader } from "components/AdvHeader";
import { TopBar } from "components/TopBar";
import { memo, useMemo } from "react";
import { IOutletAuth, IProfile } from "types";
import {
  useChurnZero,
  useHotjarPageView,
  useMenuState,
} from "./PrivateLayout.hooks";
import { ToastContainer } from "react-toastify";
import { Outlet, useOutletContext } from "react-router";
import { useUserProfile } from "graphql-requests/UserProfile";
import { useCheckPremium } from "utils";

declare global {
  interface Window {
    ChurnZero: any;
  }
}

function PrivateLayout() {
  const { toggleMenuHandler, onMouseEnter, onMouseLeave, showNavigation } =
    useMenuState();

  const context = useOutletContext<IOutletAuth>();

  const {
    data: { user },
  } = useUserProfile();

  const userData = useMemo((): Partial<IProfile> => {
    return {
      email: user?.email || context.user?.attributes?.email,
      firstName: user?.firstName || context.user?.attributes?.given_name,
      lastName: user?.lastName || context.user?.attributes?.family_name,
      profilePic: user?.profilePic,
    };
  }, [
    context.user?.attributes?.email,
    context.user?.attributes?.family_name,
    context.user?.attributes?.given_name,
    user?.email,
    user?.firstName,
    user?.lastName,
    user?.profilePic,
  ]);

  const isPremium = useCheckPremium();

  useHotjarPageView();
  useChurnZero(user);

  return (
    <>
      <TopBar
        userData={userData}
        showNavigation={showNavigation}
        toggleMenuHandler={toggleMenuHandler}
        className="z-50"
      />
      <main className="flex h-full relative overflow-y-hidden mt-14 w-full min-w-sm">
        <Navigation
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          showNavigation={showNavigation}
          className="absolute innerViewportSpecific:relative z-50"
        />
        <section
          id="main-section"
          className="flex h-full relative flex-col overflow-y-auto w-full justify-between bg-primary"
        >
          <AdvHeader isPremium={isPremium} />
          <div className="flex flex-col bg-primary flex-1">
            <Outlet context={context} />
          </div>
        </section>
        <ToastContainer />
      </main>
    </>
  );
}

export default memo(PrivateLayout);
